import { render, staticRenderFns } from "./ManageStudent.vue?vue&type=template&id=e5b8559e&scoped=true&"
import script from "./ManageStudent.vue?vue&type=script&lang=js&"
export * from "./ManageStudent.vue?vue&type=script&lang=js&"
import style0 from "./ManageStudent.vue?vue&type=style&index=0&id=e5b8559e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b8559e",
  null
  
)

export default component.exports